import { createAction, props } from '@ngrx/store';
import { Member } from '../../members.models';

export const openMembersModal = createAction('[Members] Open modal');
export const closeMembersModal = createAction('[Members] Close modal');

export const getMember = createAction('[Members] Get member', props<{ memberId: number }>());
export const getMemberResponse = createAction('[Members] Get member response', props<{ member: Member }>());

export const getMembersList = createAction('[Members] Get members list', props<{ params: any }>());
export const getMembersListResponse = createAction(
  '[Members] Get members list response',
  props<{ members: Member[] }>(),
);
export const getMemberError = createAction('[Members] Get member error', props<{ error: any }>());
export const getMembersListError = createAction('[Members] Get members list error', props<{ error: any }>());

export const loadMoreMembersList = createAction('[Members] Load more members list', props<{ params: any }>());
export const loadMoreMembersListResponse = createAction(
  '[Members] Load more members list response',
  props<{ members: Member[] }>(),
);

export const saveMember = createAction('[Members] Save member', props<{ member: Partial<Member> }>());
export const saveMemberResponse = createAction('[Members] Save member response', props<{ data: Member }>());
export const saveMemberError = createAction('[Members] Save member error', props<{ error: any }>());

export const updateMember = createAction('[Members] Update member', props<{ member: Member }>());
export const updateMemberResponse = createAction('[Members] Update member response', props<{ data: Member }>());
export const updateMemberError = createAction('[Members] Update member error', props<{ error: any }>());

export const removeMember = createAction('[Members] Remove member', props<{ memberId: number; isLogout: boolean }>());
export const removeMemberItem = createAction('[Members] Remove member item', props<{ member: Member }>());
export const removeMemberResponse = createAction('[Members] Remove member response', props<{ data: Member }>());
export const removeMemberError = createAction('[Members] Remove member error', props<{ error: any }>());
